/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Preference } from './';
import {
    PreferenceFromJSON,
    PreferenceFromJSONTyped,
    PreferenceToJSON,
} from './';

/**
 * 
 * @export
 * @interface Preferences
 */
export interface Preferences {
    /**
     * 
     * @type {string}
     * @memberof Preferences
     */
    type: PreferencesTypeEnum;
    /**
     * 
     * @type {Array<Preference>}
     * @memberof Preferences
     */
    content: Array<Preference>;
}


/**
 * @export
 */
export const PreferencesTypeEnum = {
    Duration: 'DURATION',
    ActivityArea: 'ACTIVITY_AREA',
    CompanySize: 'COMPANY_SIZE'
} as const;
export type PreferencesTypeEnum = typeof PreferencesTypeEnum[keyof typeof PreferencesTypeEnum];


/**
 * Check if a given object implements the Preferences interface.
 */
export function instanceOfPreferences(value: object): value is Preferences {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function PreferencesFromJSON(json: any): Preferences {
    return PreferencesFromJSONTyped(json, false);
}

export function PreferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): Preferences {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'content': ((json['content'] as Array<any>).map(PreferenceFromJSON)),
    };
}

export function PreferencesToJSON(value?: Preferences | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'type': value['type'],
        'content': ((value['content'] as Array<any>).map((v) => PreferenceToJSON(v))),
    };
}

